import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class PerfomanceLogIndexdbService {
  public tableName = "ba_ndc_perfomance_logs";
  constructor() { }
  addPerfomanceLog(logDetail:{label:string,responseTime:string},db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let perfomanceLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName);
        let countRequest = perfomanceLogStore.count();
        countRequest.onsuccess = function (countRequestEvent:any) {
            let perfomanceCount:any = countRequestEvent.target.result;
            logDetail.label = logDetail.label+(perfomanceCount+1);
            perfomanceLogStore.put(logDetail);
            perfomanceLogStore.onsuccess = function (event:any) {
              if(event.target.result){
                resolve(true);
              }else{
                resolve(false);
              }
            };
        };
      }
    });
  }
  getPerfomanceLogs(db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let perfomanceLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName);
        const getAllPerfomanceLogQuery = perfomanceLogStore.getAll();
        getAllPerfomanceLogQuery.onsuccess = function (event:any) {
          if(event.target.result){
            resolve(event.target.result);
          }else{
            resolve([]);
          }
        };
      }
    });
  }
  deleteAllLogs(db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let perfomanceLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName).clear();
        perfomanceLogStore.onsuccess = function (event:any) {
          if(event.target.result){
            resolve(true);
          }else{
            resolve(false);
          } 
        };
      }
    });
  }
}